import React from 'react'
const Refund_Policy_conten = () => {
    return (
        <>
        <section>
             <div className="container my-5 privacy-policy-container">
    <h2 className="mb-4">Refund Policy</h2>
    <p>Welcome to <strong>Harsafe Technology Finance Service Pvt. Ltd.</strong>. This Refund Policy explains our guidelines regarding refunds for services purchased through our app. Please read this policy carefully. By using our app or services, you agree to this refund policy.</p>

    <h4 className="mt-4">1. Eligibility for Refunds</h4>
    <p>We aim to ensure customer satisfaction. However, refunds will only be considered under the following circumstances:</p>
    <ul>
      <li>Technical issues that prevent the use of a paid service, and our support team is unable to resolve the issue.</li>
      <li>Duplicate payments due to system errors.</li>
      <li>Accidental payments reported within 24 hours of the transaction.</li>
    </ul>

    <h4 className="mt-4 ">2. Non-Refundable Services</h4>
    <p>We do not offer refunds under the following conditions:</p>
    <ul>
      <li>Change of mind after service purchase.</li>
      <li>Partial usage of a service.</li>
      <li>Service availed or completed successfully as per our terms.</li>
    </ul>

    <h4 className="mt-4">3. Refund Request Process</h4>
    <p>To request a refund, please email us at <strong>info@harsafe.com</strong> with the following details:</p>
    <ul>
      <li>Your full name and registered email</li>
      <li>Transaction ID and payment proof</li>
      <li>A detailed reason for the refund request</li>
    </ul>
    <p>All refund requests will be reviewed and responded to within 5–7 business days.</p>

    <h4 className="mt-4">4. Refund Method</h4>
    <p>If approved, the refund will be processed through the original method of payment within 7–10 working days.</p>

    <h4 className="mt-4">5. Policy Updates</h4>
    <p>We reserve the right to update or change this Refund Policy at any time. Any changes will be posted here and effective immediately.</p>

    <h4 className="mt-4">6. Contact Us</h4>
    <p>If you have any questions regarding this Refund Policy, please contact us:</p>
    <p> <strong>Email:</strong> <a href="mailto:info@harsafe.com" className='contact-link'>info@harsafe.com</a></p>
  </div>
        </section>
        </>
    )
}

export default Refund_Policy_conten;